import React from 'react';
import classNames from "classnames";
import { LazyImage, Select } from "component";
import { Link, useHistory, useLocation } from "react-router-dom";
import { navbar } from "template/header/headerStatic";
import useLang from "hook/useLang";
import ResponsiveHeader from "template/header/ResponsiveHeader";
import HeaderLabels from "template/header/HeaderLabels";
import { changeLang, createLinkBaseOnLang, removeHeaderFooter, showNavBarItem } from "tools/tools";
import languages from "assets/lang/lang";
import LangIcon from "assets/icon/LangIcon";
import ViraLogo from "assets/icon/ViraLogo";
import ViraLogoEn from "assets/icon/ViraLogoEn";
import './header.scss';
import mrestateLogoOne from "assets/icon/mrestate-logo-one.svg";
import mrestateLogoTwo from "assets/icon/mrestate-logo-two.svg";
function Header() {
    var lang = useLang();
    var location = useLocation();
    var history = useHistory();
    var homePage = location.pathname === '/' || location.pathname === "/".concat(lang.lang) || location.pathname === "/".concat(lang.lang, "/");
    var techPage = location.pathname === '/tech' || location.pathname === "/".concat(lang.lang, "/tech");
    var mediaPage = location.pathname === '/media' || location.pathname === "/".concat(lang.lang, "/media");
    var worksPage = location.pathname === '/works' || location.pathname === "/".concat(lang.lang, "/works");
    var servicesPage = location.pathname === '/services' || location.pathname === "/".concat(lang.lang, "/services");
    var aboutUs = location.pathname === '/aboutus' || location.pathname === "/".concat(lang.lang, "/aboutus");
    var mrEstateInfoPage = location.pathname === '/mrestate-info' || location.pathname === "/".concat(lang.lang, "/mrestate-info");
    var mrEstateIntroPage = location.pathname === '/mrestate-intro' || location.pathname === "/".concat(lang.lang, "/mrestate-intro");
    var mrEstateFeaturesPage = location.pathname === '/mrestate-features' || location.pathname === "/".concat(lang.lang, "/mrestate-features");
    var mrEstateMonetizationPage = location.pathname === '/mrestate-monetization' || location.pathname === "/".concat(lang.lang, "/mrestate-monetization");
    var main = classNames({
        'backHeaderHomePage': homePage,
        'backHeaderAboutUs': aboutUs,
        'min-h-screen': techPage || servicesPage || worksPage || mediaPage || mrEstateIntroPage || mrEstateFeaturesPage || mrEstateMonetizationPage,
        'bg-primary': techPage || servicesPage || mediaPage,
        'bg-mrestate': mrEstateMonetizationPage || mrEstateFeaturesPage,
        'backHeaderMrEstateInfoPage': mrEstateInfoPage
    });
    var ulClassName = classNames({
        'hidden sm:flex': true,
        'text-white': homePage || techPage || servicesPage || aboutUs || mediaPage || mrEstateFeaturesPage || mrEstateMonetizationPage,
    });
    var navBorder = classNames({
        'navbarBorder': true,
        'navbarBorder-homePage': homePage || techPage || servicesPage || aboutUs || mediaPage || mrEstateFeaturesPage || mrEstateMonetizationPage
    });
    var selectTextColor = classNames({
        'text-textColor': worksPage || mrEstateIntroPage,
        'text-white': homePage || techPage || servicesPage || aboutUs || mediaPage || mrEstateFeaturesPage || mrEstateMonetizationPage,
    });
    var selectBorderColor = classNames({
        'selectLangContainerBlack': worksPage || mrEstateIntroPage,
        'selectLangContainerWhite': homePage || techPage || servicesPage || aboutUs || mediaPage || mrEstateFeaturesPage || mrEstateMonetizationPage,
    });
    return (React.createElement("nav", { className: main },
        React.createElement("div", { className: 'sizeScreen flex items-center justify-between py-4' },
            React.createElement(ResponsiveHeader, { homePage: homePage, techPage: techPage, mediaPage: mediaPage, worksPage: worksPage, servicesPage: servicesPage, aboutUs: aboutUs, mrEstateInfoPage: mrEstateInfoPage, mrEstateIntroPage: mrEstateIntroPage, mrEstateFeaturesPage: mrEstateFeaturesPage, mrEstateMonetizationPage: mrEstateMonetizationPage }),
            React.createElement("div", { className: 'flex flex-1 items-center justify-center sm:justify-start' }, showLogo(location.pathname, lang.lang, worksPage, mrEstateIntroPage, mrEstateFeaturesPage, mrEstateMonetizationPage)),
            React.createElement("ul", { className: ulClassName }, navbar(lang.file)
                .map(function (item) {
                var show = showNavBarItem(location.pathname, item.type);
                if (!show)
                    return;
                return (React.createElement("li", { key: item.id, className: 'navbarItem ltr:ml-6 rtl:mr-6 first:m-0' },
                    React.createElement(Link, { to: createLinkBaseOnLang(location.pathname, item.href) },
                        React.createElement("p", { className: 'text-16 font-medium' }, item.title),
                        React.createElement("div", { className: navBorder }))));
            })),
            !removeHeaderFooter(location.pathname) &&
                React.createElement(Select, { value: lang, label: '\u0632\u0628\u0627\u0646 \u0633\u0627\u06CC\u062A', data: languages, className: "".concat(selectBorderColor, " text-center sm:rtl:mr-4 rtl:pl-6 rtl:pr-2 sm:ltr:ml-4 ltr:pr-6"), classNameLabel: "".concat(selectTextColor, " text-14 font-medium"), classNameIcon: "rtl:left-1 ltr:right-1 ".concat(selectTextColor), labelIcon: React.createElement(LangIcon, { className: "w-4 h-auto rtl:ml-3 ltr:mr-3 ".concat(selectTextColor) }), onClick: function (item) {
                        if (item.lang && lang.lang !== item.lang) {
                            history.push(changeLang(location.pathname, item.lang));
                        }
                    } })),
        React.createElement(HeaderLabels, { homePage: homePage, techPage: techPage, mediaPage: mediaPage, worksPage: worksPage, servicesPage: servicesPage, mrEstateInfoPage: mrEstateInfoPage, mrEstateIntroPage: mrEstateIntroPage, mrEstateFeaturesPage: mrEstateFeaturesPage, mrEstateMonetizationPage: mrEstateMonetizationPage, aboutUs: aboutUs })));
}
var showLogo = function (pathname, lang, worksPage, mrEstateIntroPage, mrEstateFeaturesPage, mrEstateMonetizationPage) {
    var logo;
    var logoClassName;
    var link;
    if (pathname.search('mrestate') !== -1) {
        link = '/mrestate-info';
        logoClassName = classNames({
            'w-32 h-auto': true
        });
        var img = mrEstateFeaturesPage || mrEstateMonetizationPage ? mrestateLogoTwo : mrestateLogoOne;
        logo = React.createElement(LazyImage, { dataSrc: img, defaultImage: img, noScriptSrc: img, className: logoClassName, alt: 'mrestate-logo' });
    }
    else {
        link = '/';
        logoClassName = classNames({
            'w-36 sm:w-44 h-auto': lang === 'fa',
            'w-20 sm:w-24 h-auto': lang !== 'fa',
            'text-white': !worksPage || mrEstateIntroPage,
            'text-textColor': worksPage || mrEstateIntroPage,
        });
        if (lang === 'fa') {
            logo = React.createElement(ViraLogo, { className: logoClassName });
        }
        else {
            logo = React.createElement(ViraLogoEn, { className: logoClassName });
        }
    }
    return (React.createElement(Link, { to: createLinkBaseOnLang(pathname, link) }, logo));
};
export default Header;
